import { render, staticRenderFns } from "./DcumentsGroupsFormDlg.vue?vue&type=template&id=483a4b8d&"
import script from "./DcumentsGroupsFormDlg.vue?vue&type=script&lang=js&"
export * from "./DcumentsGroupsFormDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports